// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"5cc1cfef","375":"cb27102e","442":"bc458c22","615":"bdf1afde","673":"78d3d91e"}[chunkId] + ".css";
};